import { useState } from 'react';
import ChargerModule from '../../components/chargerModule';
import LogisticsServicesFilters from './components/LogisticsServicesFilters/LogisticsServicesFilters';
import { LogisticServiceListing, LogisticServiceListingFilter, LogisticsServicesTrello } from './components';
import useFiltersState from '../../state/useFiltersState';
import { ISharedModules } from '../../types/orders';
import useServiceState from '../../state/useServicesState';
import './servicesModule.scss';

const ServicesModule = () => {
  const { servicesNumber } = useServiceState();
  const {
    setLogisticServicesSearchbarText,
    logisticsServicesSearchbarText,
    logisticServiceSharedModule,
    setLogisticServiceSharedModule
  } = useFiltersState();
  const [firstLoad, setFirstLoad] = useState<boolean>(true);
  const [firstLoadSecondList, setFirstLoadSecondList] = useState<boolean>(true);

  const [sharedModules, setSharedModules] = useState<ISharedModules[]>([
    { title: 'Trello', key: 1, active: true },
    { title: 'Listing', key: 2, active: false }
  ]);

  const headerInfo = {
    title: `Servicios logísticos ${servicesNumber ? '-' : ''}`,
    subtitle: `${servicesNumber ? `${servicesNumber}` : ''}`
  };
  const infoSideBar = { position: 'logisticService' };
  const searchbarPlaceholder = 'Buscar empresa, serial, número de SL, número de PO';

  const sharedModulesAction = (key: number) => {
    const newList: ISharedModules[] = [];
    for (const module of sharedModules) {
      const newModule = {
        key: module.key,
        title: module.title,
        active: module.key === key ? true : false
      };
      if (newModule.active) {
        setLogisticServiceSharedModule(newModule);
      }
      newList.push(newModule);
    }
    setSharedModules([...newList]);
  };

  const changeStateFirsLoad = (state: boolean) => {
    setFirstLoad(state);
  };

  const changeStateFirsLoadSecondList = (state: boolean) => {
    setFirstLoadSecondList(state);
  };

  const tabIsLsTrello = logisticServiceSharedModule?.key === 1;
  const tabIsLsListing = logisticServiceSharedModule?.key === 2;
  const loadingSearchBar = tabIsLsTrello ? firstLoad : tabIsLsListing ? firstLoadSecondList : false;

  return (
    <div className="servicesModule">
      <ChargerModule
        searchText={logisticsServicesSearchbarText}
        headerInfo={headerInfo}
        infoSideBar={infoSideBar}
        sharedModule={logisticServiceSharedModule}
        viewSearchBar
        setSearchText={setLogisticServicesSearchbarText}
        sharedModules={sharedModules}
        sharedModulesAction={sharedModulesAction}
        searchbarPlaceholder={searchbarPlaceholder}
        loadingSearchBar={loadingSearchBar}
      >
        {logisticServiceSharedModule?.key === 1 && (
          <>
            <LogisticsServicesFilters />
            <LogisticsServicesTrello
              searchText={logisticsServicesSearchbarText}
              changeStateFirsLoad={changeStateFirsLoad}
            />
          </>
        )}
        {logisticServiceSharedModule?.key === 2 && (
          <>
            <LogisticServiceListingFilter />
            <LogisticServiceListing
              searchText={logisticsServicesSearchbarText}
              changeStateFirsLoadSecondList={changeStateFirsLoadSecondList}
            />
          </>
        )}
      </ChargerModule>
    </div>
  );
};
export default ServicesModule;
